import { observable, action, toJS, computed, makeObservable, runInAction } from 'mobx'
import api from '../service/api'
import UserStore from "./user.store"
import React from 'react'
import { toast } from 'react-toastify'
import { shuffleArray } from '../utils/utilities'
import dayjs from 'dayjs'
// import UserStore from "./user.store";

class AdmissionExamStore {
    exams
    selectedExam

    constructor () {
        this.currentRemainingTime = Infinity
        this.selectedLanguageForExamQuestions = localStorage.getItem( "preferedLanguage" ) || localStorage.getItem( "preferedLanguage" ) || "en"
        this.translationsDetails = null
        this.selectedExam = {}
        this.exams = []
        this.examQuestionsDetails = {
            questionFiles: [], questions: [], sections: []
        }
        this.attemptQuestions = []
        this.attemptSubmissions = []
        this.api = api
        this.errors = {
            exam: null,
            examQuestionsDetails: null,
        }
        this.attemptDetails = {
            currentQuestionIndex: 0,
            sections: [],
            currentSection: null,
            currentQuestion: null,
            remainingTime: Infinity,
            examDuration: "",
            endsAt: null
        }


        makeObservable( this, {

            selectedLanguageForExamQuestions: observable,
            attemptDetails: observable,
            attemptQuestions: observable,
            attemptSubmissions: observable,
            examQuestionsDetails: observable,
            translationsDetails: observable,
            selectedExam: observable,
            exams: observable,

            setExamQuestionsLanguage: action,
            moveToNextQuestion: action,
            fetchExamLanguages: action,
            selectQuestion: action,
            fetchExamQuestions: action,
            setCurrentAttemptSection: action,
            startExam: action,
            fetchAttemptSubmissions: action,
            fetchExamsBySubject: action,
            fetchPendingExams: action,
            setSelectedExam: action,
            createExam: action,
            updateExam: action,
            fetchExams: action,
            fetchExam: action,
            setExams: action,

            getAttemptSubmissions: computed,
            getTranslationDetails: computed,
            getAttemptDetails: computed,
            getAttemptQuestions: computed,
            getExamQuestionSections: computed,
            getExamQuestionFiles: computed,
            getExamQuestions: computed,
            getExams: computed,
            getExam: computed,
        } )
    }




    _uniqueSubmissions ( subs ) {
        const unique = []
        const map = new Map()

        subs.forEach( item => {
            const combinedKey = item['question_id']
            if ( !map.has( combinedKey ) ) {
                map.set( combinedKey, true )
                unique.push( item )
            }
        } )
        return unique
    }

    async createExam ( payload ) {
        try {
            await this.api.admissionExams.createExam( payload )
        } catch ( err ) {
            console.log( err )
            toast( err?.response?.data?.message || "Something went wrong!", { containerId: "main" } )
        }
    }

    async fetchExams ( params ) {
        try {
            const res = await this.api.admissionExams.getAllExams( params )
            if ( res.data.success === true || res.data.data ) {
                this.setExams( res.data.data )
                return { success: true }
            } else
                return { success: false }
        } catch ( err ) {
            console.log( err, err.status, err?.response?.status )
            if ( err?.response?.status === 401 || err?.response?.data?.unauth ) {
                UserStore.setERPSessionState( "ended" )
                return { success: false, error: { code: err?.response?.status, message: "Session ended please signin" } }
            } else
                return { success: false, error: { code: err?.response?.status, message: err?.response?.data?.message || err?.response?.data || "Something went wrong while fetching the exams" } }
        }
    }

    async fetchExamQuestions ( examId ) {
        try {
            const { data: { data } } = await this.api.admissionExams.fetchExamQuestions( examId )
            runInAction( () => {

                this.examQuestionsDetails = data
                this.errors.examQuestionsDetails = null
            } )
        } catch ( err ) {
            console.log( err )
            toast( err?.response?.data?.message || "Failed to fetch exam questions!" )
            runInAction( () => {
                this.errors.examQuestionsDetails = { message: err?.response?.data?.message || "Something went wrong while fetching exam question details! please try again.", code: err?.response?.status }
            } )
        }
    }

    async fetchAttemptSubmissions ( examId, participationId ) {
        try {
            const { data: { data } } = await this.api.admissionExams.fetchParticipationSubmissions( examId, participationId )
            runInAction( () => {
                this.attemptSubmissions = this._uniqueSubmissions( data )
            } )
        } catch ( err ) {
            console.log( err )
            toast( err?.response?.data?.message || "Failed to fetch your submissions!" )
        }
    }

    async fetchExamLanguages ( examId ) {
        try {
            const { data: { data } } = await this.api.admissionExams.fetchTranslationsAvailable( examId )

            runInAction( () => {
                if ( !data )
                    this.translationsDetails = null
                else {

                    const { languages = [], defaultLang } = data
                    const storedLang = this.selectedLanguageForExamQuestions

                    const translationDetails = {}
                    translationDetails.translationsAvailable = languages.length > 1
                    translationDetails.translationLanguges = languages
                    translationDetails.defaultLanguage = defaultLang
                    translationDetails.selectedLanguage = languages.includes( storedLang ) ? storedLang : defaultLang
                    this.translationsDetails = translationDetails
                }

            } )

        } catch ( err ) {
            console.log( err )
            runInAction( () => {
                this.errors.examLanguages = { message: err?.response?.data?.message || "Something went wrong while fetching exam question languages details! please try again.", code: err?.response?.status }
            } )
        }
    }

    async startExam ( examId, participationId ) {
        try {

            const deviceData = {}

            deviceData.platform = navigator?.userAgentData?.platform
            deviceData.userAgent = navigator?.userAgent
            deviceData.vendor = navigator?.vendor
            const { data: examStartDetails } = await api.admissionExams.startExam( examId, participationId, { device_data: deviceData } )

            const { data: { data: questionsDetails } } = await api.admissionExams.fetchQuestionsForAttempt( examId, participationId )

            if ( this.selectedExam.exam.enable_randomize )
                shuffleArray( questionsDetails.questions )

            runInAction( () => {
                this.attemptQuestions = questionsDetails.questions || []
                this.attemptDetails.currentQuestionIndex = 0
                this.attemptDetails.sections = questionsDetails.sections || []
                this.attemptDetails.currentSection = this.attemptDetails.sections[0] || ""
                this.attemptDetails.currentQuestion = this.getFilteredAttemptQuestions[this.attemptDetails.currentQuestionIndex]
                this.examQuestionsDetails.sections = questionsDetails.sections || []
                this.attemptDetails.remainingTime = examStartDetails.duration

                const endsAt = dayjs().add( +examStartDetails.duration, 'seconds' )

                this.attemptDetails.endsAt = endsAt
                this.currentRemainingTime = examStartDetails.duration
                this.attemptDetails.examDuration = examStartDetails.totalDuration
            } )
            return true
        } catch ( err ) {
            console.log( err )
            toast( err?.response?.data?.message || "Failed to start exam attempt!" )
            return false
        }
    }

    async fetchExamsByDept ( deptCode ) {
        try {
            const res = await api.admissionExams.fetchExamsByDept( deptCode )
            if ( res.data.success === true || res.data.exams ) {
                this.setExams( res.data.exams )
                return true
            } else
                return false
        } catch ( err ) {
            console.log( err )
            if ( err?.response?.status === 401 || err?.response?.data?.unauth ) {
                UserStore.setERPSessionState( "ended" )
            } else
                toast( err?.response?.data?.message || "Something went wrong!", { containerId: "main" } )
        }
    }

    async fetchExamsByInstitute ( institute ) {
        try {
            const { data } = await api.admissionExams.fetchExamsByInstitute( institute )
            if ( data.success === true || data.exams ) {
                this.setExams( data.exams )
                return true
            } else {
                console.log( data )
                return false
            }
        } catch ( err ) {
            console.log( err )
            if ( err?.response?.status === 401 || err?.response?.data?.unauth ) {
                UserStore.setERPSessionState( "ended" )
            } else
                toast( err?.response?.data?.message || "Something went wrong!", { containerId: "main" } )
        }
    }

    async fetchExamsBySubject ( subject ) {
        try {
            const { data } = await api.admissionExams.fetchExamsBySubject( subject )
            if ( data.success === true || data.data ) {
                this.setExams( data.data )
                return true
            } else {
                console.log( data )
                return false
            }
        } catch ( err ) {
            console.log( err )
            if ( err?.response?.status === 401 || err?.response?.data?.unauth ) {
                UserStore.setERPSessionState( "ended" )
            } else
                toast( err?.response?.data?.message || "Something went wrong!", { containerId: "main" } )
        }
    }


    async fetchPendingExams ( subjectId ) {
        try {
            const { data } = await api.admissionExams.fetchPendingExams( { subjectId } )
            if ( data.success === true || data.data ) {
                this.setExams( data.data )
                return true
            } else {
                console.log( data )
                return false
            }
        } catch ( err ) {
            console.log( err )
            if ( err?.response?.status === 401 || err?.response?.data?.unauth ) {
                UserStore.setERPSessionState( "ended" )
            } else
                toast( err?.response?.data?.message || "Something went wrong!", { containerId: "main" } )
        }
    }


    async updateExam ( id, payload ) {
        try {
            const res = await this.api.admissionExams.updateExam( id, payload )
            if ( res.status === 200 ) {
                toast( "Exam updated", { containerId: "main" } )
            }
            await this.fetchExam( id )

        } catch ( err ) {
            console.log( err )
            toast( err?.response?.data?.message || "Something went wrong!", { containerId: "main" } )
        }
    }

    async fetchExam ( id ) {
        try {
            const res = await this.api.admissionExams.getExam( id )
            this.setSelectedExam( res.data )
            return { success: true, code: 200 }
        } catch ( err ) {
            console.log( err )
            if ( err?.response?.status === 401 || err?.response?.data?.unauth ) {
                UserStore.setERPSessionState( "ended" )
                return { success: false, error: { code: err?.response?.status, message: "Session ended please signin" } }
            } else
                return { success: false, error: { code: err?.response?.status || 500, message: err?.response?.data?.message || err?.response?.data || "Something went wrong while fetching the exam" } }
        }
    }

    setExamQuestionsLanguage ( lang ) {
        this.selectedLanguageForExamQuestions = lang
        if ( !this.translationsDetails )
            this.translationsDetails = {}
        this.translationsDetails.selectedLanguage = lang

        localStorage.setItem( 'preferedLanguage', lang )
    }



    moveToNextQuestion () {
        let nextIndex = this.attemptDetails.currentQuestionIndex + 1
        if ( nextIndex >= this.getFilteredAttemptQuestions.length ) {
            let currentSectionIndex = this.attemptDetails.sections.indexOf( this.attemptDetails.currentSection )
            currentSectionIndex += 1
            if ( currentSectionIndex >= this.attemptDetails.sections?.length ) {
                currentSectionIndex = 0
            }
            nextIndex = 0
            this.attemptDetails.currentQuestionIndex = nextIndex
            this.attemptDetails.currentSection = this.attemptDetails.sections[currentSectionIndex]
            this.attemptDetails.currentQuestion = this.getFilteredAttemptQuestions[nextIndex]
        } else {
            this.attemptDetails.currentQuestionIndex = nextIndex
            this.attemptDetails.currentQuestion = this.getFilteredAttemptQuestions[nextIndex]
        }

        /*let nextIndex = currentIndex + 1
        if ( nextIndex >= filteredQuestions.length ) {
            let currentSectionIndex = allQuestionSections.indexOf( section )
            currentSectionIndex += 1
            if ( currentSectionIndex >= allQuestionSections?.length ) {
                currentSectionIndex = 0
            }
            nextIndex = 0
            setCurrentIndex( nextIndex )
            setCurrentQuestion( filteredQuestions[nextIndex] )
            setSection( allQuestionSections[currentSectionIndex] )
        } else {
            setCurrentIndex( nextIndex )
            setCurrentQuestion( filteredQuestions[nextIndex] )
        }*/

    }

    selectQuestion ( questionId ) {

        const questionIndex = this.getFilteredAttemptQuestions.findIndex( q => q.question.question_id === questionId )

        this.attemptDetails.currentQuestionIndex = questionIndex
        this.attemptDetails.currentQuestion = this.getFilteredAttemptQuestions[questionIndex]
    }

    setCurrentAttemptSection ( section ) {
        this.attemptDetails.currentSection = section
        this.attemptDetails.currentQuestionIndex = 0
        this.attemptDetails.currentQuestion = this.getFilteredAttemptQuestions[this.attemptDetails.currentQuestionIndex]
    }

    get getExam () {
        return toJS( this.selectedExam )
    }

    get getExams () {
        return toJS( this.exams )
    }

    get getTranslationDetails () {
        return toJS( this.translationsDetails )
    }

    get getExamQuestionSections () {
        return toJS( this.examQuestionsDetails.sections || [] )
    }

    get getExamQuestionFiles () {
        return toJS( this.examQuestionsDetails.questionFiles || [] )
    }

    get getExamQuestions () {
        return toJS( this.examQuestionsDetails.questions || [] )
    }

    get getAttemptQuestions () {
        return toJS( this.attemptQuestions )
    }

    get getFilteredAttemptQuestions () {
        if ( this.attemptDetails.sections.length > 0 ) {
            const section = this.attemptDetails.currentSection
            const filtered = this.attemptQuestions.filter( q => q.question.question_section === section )
            return toJS( filtered )
        }
        return this.attemptQuestions
    }

    get getAttemptDetails () {
        return toJS( this.attemptDetails )
    }

    get getAttemptSubmissions () {
        return toJS( this.attemptSubmissions )
    }


    setExams ( exams ) {
        runInAction( () => {
            this.exams = exams
        } )
    }

    setSelectedExam ( exam ) {
        this.selectedExam = exam
    }

}


const AdmissionExamStoreInstance = new AdmissionExamStore()

export default AdmissionExamStoreInstance

const AdmissionExamStoreContext = React.createContext()

export const AdmissionExamStoreProvider = ( { children, store } ) => {
    return (
        <AdmissionExamStoreContext.Provider value={store}>{children}</AdmissionExamStoreContext.Provider>
    )
}

/* Hook to use store in any functional component */
export const useAdmissionExamStore = () => React.useContext( AdmissionExamStoreContext )